import { Text, Button, Modal, ModalManagerContext, Flex, Link } from '@pega/cosmos-react-core';
import React, { useContext } from 'react';
import useLocalTranslation from '../../hooks/useLocalTranslation';
import { confirmationAlertProps, customModalProps } from '../../interfaces/common';
import { StyledLinkHover, linkTextStyle } from '../monitor/Alerts';

export const ConfirmationAlert: React.FC<confirmationAlertProps> = (props) => {
  const { pageName, deleteChannel, isErroWebhook, webhookToBeDeleted } = props;
  const translate = useLocalTranslation();
  const { ModalContext } = useContext(ModalManagerContext);
  const { dismiss } = useContext(ModalContext);
  return (
    <Modal
      center={true}
      heading=""
      autoWidth={true}
      actions={
        <>
          <Button onClick={dismiss}>{translate('cancel')}</Button>
          <Button
            variant="primary"
            onClick={() => {
              dismiss();
              deleteChannel && !isErroWebhook && deleteChannel();
              deleteChannel && isErroWebhook && deleteChannel(webhookToBeDeleted);
            }}
          >
            {translate('ok')}
          </Button>
        </>
      }
    >
      {isErroWebhook ? (
        <Flex
          container={{
            direction: 'column',
            itemGap: 3,
          }}
        >
          <Text>{`${translate('delete_modal_confirmation_label_error_webhook')} ?`}</Text>
          <Link href="" as={StyledLinkHover} style={linkTextStyle}>
            {webhookToBeDeleted}
          </Link>
        </Flex>
      ) : (
        <Text>{`${translate('delete_modal_confirmation_label')} ${pageName}?`}</Text>
      )}
    </Modal>
  );
};

export const CustomModal: React.FC<customModalProps> = (props) => {
  const { heading, actions, style, onAfterClose } = props;
  return (
    <Modal
      heading={heading}
      actions={actions}
      center={true}
      style={{ borderRadius: 0, ...style }}
      onAfterClose={onAfterClose}
    >
      {props.children}
    </Modal>
  );
};
